import "./login.scss";
import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  Card,
  Container,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import LoadingButton from "@mui/lab/LoadingButton";
import { login } from "../../context/actions/auth/login";
import { GlobalContext } from "../../context/Provider";
import { logoutDoctor } from "../../utils";
import { Isologotipo } from "../../assets/isoLogotipo";

const Login = () => {
  const [values, setValues] = React.useState({
    showPassword: false,
  });
  const { roleUser, setRoleUser } = useContext(GlobalContext);
  const [role, setRole] = useState("")
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("")
  const navigate = useNavigate();

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const onSubmit = async (data) => {
    logoutDoctor();
    setLoading(true);
    try {
      const payload = {
        email: data.email,
        password: data.password,
      };
      const response = await login(payload);
      if (response.error) {
        navigate("/backoffice");
        return;
      }
      setRole(response.rol); 
      setRoleUser(response.rol)
      if (role?.id === 2 ) {
         navigate("/medical-staff");
      } else {
        navigate("/home");
      }
     
    } catch (error) {
      console.error('Login error:', error);
      setErrorMessage(error.errors?.[0] || "Error en el inicio de sesión");
    } finally {
      setLoading(false);
    }
  };
  
 
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Ingresa un Email válido")
        .max(100, "El campo Email puede tener hasta 100 caracteres")
        .required("El campo Email es requerido"),
      password: Yup.string().max(255).required("La contraseña es requerida"),
    }),
    onSubmit: (data) => onSubmit(data),
  });

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        marginTop: 20,
      }}
    >
      <Container maxWidth="sm">
        <Card sx={{ padding: "20px", textAlign:"center" }}>
        <Isologotipo/>
          <form onSubmit={formik.handleSubmit}>
            <Box sx={{ my: 1, mt: 5 }}>
              <Typography align="center" fontWeight={400} fontSize={30}>
                Backoffice
              </Typography>
              {errorMessage && (
                <Typography
                  align="center"
                  sx={{
                    fontSize: "0.84rem",
                    lineHeight: "1.5rem",
                    fontWeight: "300",
                    color: "red",
                  }}
                >
                  {errorMessage}
                </Typography>
              )}
            </Box>
            <Box
              sx={{
                pb: 1,
                pt: 1,
              }}
            >
              <Typography align="center" color="textSecondary" variant="body1">
                Completá los datos para ingresar a la plataforma
              </Typography>
            </Box>
            <TextField
              error={Boolean(formik.touched.email && formik.errors.email)}
              fullWidth
              helperText={formik.touched.email && formik.errors.email}
              label="Email"
              margin="normal"
              name="email"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type="email"
              value={formik.values.email}
              variant="outlined"
            />
            <TextField
              error={Boolean(formik.touched.password && formik.errors.password)}
              fullWidth
              helperText={formik.touched.password && formik.errors.password}
              label="Contraseña"
              margin="normal"
              name="password"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type={values.showPassword ? "text" : "password"}
              value={formik.values.password}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {values.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Box sx={{ py: 2 }}>
              <LoadingButton
                loading={loading}
                loadingPosition="start"
                color="primary"
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                disabled={!formik.isValid}
              >
                Iniciar sesión
              </LoadingButton>
            </Box>
          </form>
        </Card>
      </Container>
    </Box>
  );
};

export default Login;
